import requestModule from '../libs/requestModule'
import CartController from '@/assets/controllers/CartController'
import moment from 'moment'
import Util from '@/assets/libs/util.js'

const fidelityGcomParams = {
    apiUrl: Util.getLocalConfigs('fidelityGcom') ? Util.getLocalConfigs('fidelityGcom').gComUrl : '',
    brandId: Util.getLocalConfigs('fidelityGcom') ? Util.getLocalConfigs('fidelityGcom').brandId : '',
    gComToken: Util.getLocalConfigs('fidelityGcom') ? Util.getLocalConfigs('fidelityGcom').gComToken : ''
}
const apiHeaders = {'Authorization': `Bearer ${fidelityGcomParams.gComToken}`}
const cnpj = Util.getLocalConfigs('storeCNPJ') // '06098247000179'
const storeId = '4328' // hardCode no momento
// Events
const GET_CONSUMER_BALANCE = fidelityGcomParams.apiUrl + '/getConsumerBalance'
const BALANCE_RESERVE = fidelityGcomParams.apiUrl + '/balanceReserve'
const DELETE_RESERVE = fidelityGcomParams.apiUrl + '/deleteReserve'
const GENERATE_BALANCE = fidelityGcomParams.apiUrl + '/generateBalance'

let gcomFidelityBalance = null
let reserve = null
let products = []
let count = 0

const getApiGcomStatus = async function () {
    if (!fidelityGcomParams.apiUrl || !fidelityGcomParams.brandId || !fidelityGcomParams.gComToken) {
        return false
    }
    return true
}

const getBalance = async function (phone) {
    let params = buildRequest()
    params.root.data.storeId = storeId
    params.root.data.brandId = fidelityGcomParams.brandId
    params.root.data.consumerPhone = phone
    let result = await requestModule.xmlRequest(GET_CONSUMER_BALANCE, 'post', params, apiHeaders)
    if (!result || !result.root || !result.sucesso || result.root.error._text === 'true') {
        let errorMessage = getResultErrorMessage(result) || 'Falha na rotina getBalance'
        console.log(errorMessage)
        return false
    }
    gcomFidelityBalance = result && result.root && result.root.data
    return gcomFidelityBalance
}

const balanceReserve = async function (value) {
    // data espera o retorno da getbalande
    let params = buildRequest()
    params.root.data.value = value ? value.toString().replace('.', ',') : 0
    params.root.data.branchId = gcomFidelityBalance.branchId._text
    params.root.data.fidelityId = gcomFidelityBalance.fidelityId._text
    params.root.data.fildetyVersion = gcomFidelityBalance.fidelityVersion._text
    params.root.data.brandId = fidelityGcomParams.brandId
    params.root.data.storeId = storeId
    params.root.data.consumerId = gcomFidelityBalance.consumerId._text
    let result = await requestModule.xmlRequest(BALANCE_RESERVE, 'post', params, apiHeaders)
    if (!result || !result.root || !result.sucesso || result.root.error._text === 'true') {
        let errorMessage = getResultErrorMessage(result) || 'Falha na rotina balanceReserve'
        // throw new Error(errorMessage)
        console.log(errorMessage)
        return {
            error: true,
            message: errorMessage
        }
    }
    reserve = result && result.root && result.root.data
    console.log(`Desconto de ${value} aplicado.`)
    return reserve
}

const deleteReverve = async function () {
    let params = buildRequest()
    if (reserve && reserve.reserveId) {
        params.root.data.reserveId = reserve.reserveId._text
        params.root.data.consumerId = gcomFidelityBalance.consumerId._text
        let result = await requestModule.xmlRequest(DELETE_RESERVE, 'post', params, apiHeaders)
        if (!result || !result.root || !result.sucesso || result.root.error._text === 'true') {
            let errorMessage = getResultErrorMessage(result) || 'Falha na rotina deleteReverve'
            console.log(errorMessage)
        }
        return result && result.root && result.root.data
    }
    return false
}

const generateBalance = async function (saledata, discount, phone, totalSaleValue) {
    let params = buildRequest()
    totalSaleValue = CartController.getTotalPriceAsFloat(false, false) // true para nao somar a taxa de serviço
    let eligibleValue = parseFloat(totalSaleValue) - parseFloat(discount)
    let serviceTax = null
    let modoentrega = Util.getLocalVar('modoentrega')
    let toTravel = modoentrega === 'levar'
    let driveThru = modoentrega === 'drive'
    if (Util.isTapMode) {
        serviceTax = CartController.getMainComandaAgregada().serviceTax
        if (serviceTax !== null) eligibleValue = eligibleValue - parseFloat(serviceTax)
    }
    eligibleValue = eligibleValue < 0.01 ? 0 : eligibleValue
    params.root.data.brandId = fidelityGcomParams.brandId
    params.root.data.cnpj = cnpj
    params.root.data.origin = 'null'
    params.root.data.orderOrigin = (toTravel || driveThru) ? 'TGO_TAA' : 'BAL_TAA'
    params.root.data.isTakeOut = toTravel
    params.root.data.subProjectId = 'null'
    params.root.data.saleCode = saledata.saleSeq
    params.root.data.saleExtCode = saledata.saleSeq
    params.root.data.saleDate = moment().format('DD/MM/YYYY HH:mm')
    params.root.data.totalValue = saledata.saleTotalAmount
    params.root.data.eligibleValue = eligibleValue.toFixed(2)
    params.root.data.deliveryFee = 0
    params.root.data.serviceFee = serviceTax != null ? serviceTax : 0
    params.root.data.discount = saledata.GcomDiscount
    params.root.data.products = products.length > 0 ? products : buildProducts()
    params.root.data.client = {
        consumerName: gcomFidelityBalance.consumerName._text || 'null',
        cpf: gcomFidelityBalance.cpf._text || 'null',
        phone: gcomFidelityBalance.phone._text || phone
    }
    params.root.data.cashback = {
        reserveId: (reserve && reserve.reserveId && reserve.reserveId._text) || 0,
        usedCashback: (reserve && !!reserve.reserveId && !!reserve.reserveId._text) || false,
        usedCashbackValue: (reserve && !!reserve.reserveId && !!reserve.reserveId._text) ? discount : 0
    }

    let result = await requestModule.xmlRequest(GENERATE_BALANCE, 'post', params, apiHeaders)
    if (!result || !result.root || !result.sucesso || result.root.error._text === 'true') {
        await deleteReverve()
        let errorMessage = getResultErrorMessage(result) || 'Falha na rotina generateBalance'
        throw new Error(errorMessage)
    }
    return result && result.root && result.root.data
}

function buildRequest () {
    const params = {
        root: { data: {} }
    }
    return params
}
function getResultErrorMessage (result) {
    let errorMessage = ((result.root && result.root.message && result.root.message._text) || (result.message) || '')
    return errorMessage
}
function buildProducts () {
    let prod = []
    let cart = CartController.getCart()
    /* a função price update coloca o price 0 em todos os produtos no carrinho
        que não alteram o preço, nesse caso percorre o carrinho e adiciona no products
        somente quem tem preço diferente de 0 */
    cart.forEach((e) => {
        if (e.price !== 0) {
            let item = {
                productCode: e.productCode,
                productName: e.productName,
                quantity: e.quantity || 1,
                value: e.price || e.itemValue,
                discount: e.discount
            }
            count++
            prod.push(item)
        }
        e.observations.forEach((obs) => {
            if (obs.price !== 0) {
                let item = {
                    productCode: obs.obsProductCode,
                    productName: obs.obsName,
                    quantity: 1,
                    value: obs.price,
                    discount: obs.discount
                }
                count++
                prod.push(item)
            }
        })
        e.productCombo.forEach((c) => {
            if (c.price !== 0) {
                let item = {
                    productCode: c.subItemCode,
                    productName: c.subItemName,
                    quantity: c.quantity || 1,
                    value: c.price,
                    discount: c.discount
                }
                count++
                prod.push(item)
            }
            if (c.observations && c.observations.length) {
                c.observations.forEach((cObs) => {
                    if (cObs.price !== 0) {
                        let item = {
                            productCode: cObs.subItemObsProductCode,
                            productName: cObs.subItemObsName,
                            quantity: 1,
                            value: cObs.price,
                            discount: cObs.discount
                        }
                        count++
                        prod.push(item)
                    }
                })
            }
            if (c.choosen) {
                Object.keys(c.choosen).forEach((key) => {
                    c.choosen[key].forEach((cc) => {
                        if (cc.price !== 0) {
                            let item = {
                                productCode: cc.subItemCode,
                                productName: cc.subItemName,
                                quantity: 1,
                                value: cc.price,
                                discount: cc.discount
                            }
                            count++
                            prod.push(item)
                        }
                        if (cc.observations && cc.observations.length) {
                            cc.observations.forEach((ccObs) => {
                                if (ccObs.price !== 0) {
                                    let item = {
                                        productCode: ccObs.subItemObsProductCode,
                                        productName: ccObs.subItemObsName,
                                        quantity: 1,
                                        value: ccObs.price,
                                        discount: ccObs.discount
                                    }
                                    count++
                                    prod.push(item)
                                }
                            })
                        }
                    })
                })
            }
        })
    })
    products = [{
        'prod': prod
    }]
    return products
}
export default {
    getApiGcomStatus,
    getBalance,
    balanceReserve,
    deleteReverve,
    generateBalance,
    getBalanceValue: (totalSale) => {
        if (gcomFidelityBalance.status && gcomFidelityBalance.status._text !== 'S') {
            return {
                available: 0,
                maxValue: 0
            }
        }
        let totalSaleValue = CartController.getTotalPriceAsFloat(false, false)
        let serviceTax = (Util.isTapMode && CartController.getMainComandaAgregada().serviceTax) ? CartController.getMainComandaAgregada().serviceTax : 0.00

        if (gcomFidelityBalance.balance) {
            let value = parseFloat(gcomFidelityBalance.balance._text) // valor total disponivel para desconto
            let redemptionPercentage = gcomFidelityBalance.redemptionPercentage._text && gcomFidelityBalance.redemptionPercentage._text !== '0' ? parseFloat(gcomFidelityBalance.redemptionPercentage._text) / 100 : 1 // porcentagem maxima perimitida
            let maxDiscount = (redemptionPercentage * parseFloat(totalSaleValue)) - serviceTax // valor maximo de desconto permitido nessa venda (a taxa de serviço não pode ser considerada para uso ou resgate de cashback)

            if (maxDiscount > value) {
                maxDiscount = value
            }
            if (maxDiscount >= totalSaleValue) {
                if (count === 0) {
                    buildProducts()
                }
                maxDiscount = maxDiscount - (count / 100)
            }
            return {
                available: value,
                maxValue: maxDiscount
            }
        }
        return 0
    },
    getConsumerData: () => {
        let consumerData = {
            consumerName: gcomFidelityBalance && gcomFidelityBalance.consumerName && gcomFidelityBalance.consumerName._text,
            consumerId: gcomFidelityBalance && gcomFidelityBalance.consumerId && gcomFidelityBalance.consumerId._text
        }
        return {
            consumerData: consumerData,
            campaignEnable: 3
        }
    },
    clearData: function () {
        gcomFidelityBalance = null
        reserve = null
        products = []
        count = 0
    }
}



// WEBPACK FOOTER //
// ./src/assets/controllers/CampaignFidelityGcomController.js